import { alertActionTypes } from '../actions/alertActions.js';

const initState = {
  open: false,
  onClose: null,
  message: '',
  action: null,
  variant: 'success',
  vertical: 'bottom',
  horizontal: 'left',
  time: 600,
};

const handleOpenAlert = (state, { message, action, variant, vertical, horizontal, time }) => {
  return {
    ...state,
    ...{
      open: true,
      message,
      action,
      variant,
      vertical,
      horizontal,
      time,
    },
  };
};

const handleCloseAlert = (state, { onClose }) => {
  return {
    ...state,
    ...{
      open: false,
      onClose,
    },
  };
};

export default function reduce(state = initState, action) {
  switch (action.type) {
    case alertActionTypes.openAlert:
      return handleOpenAlert(state, action);

    case alertActionTypes.closeAlert:
      return handleCloseAlert(state, action);

    default:
      return state;
  }
}
